export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    me: () => [...queryKeys.auth.all, 'me'] as const,
  },
  dashboard: {
    all: ['dashboard'] as const,
    scoped: (centreId: string, sessionId: string) =>
      ['dashboard', centreId, sessionId] as const,
  },
  admissions: {
    all: ['admissions'] as const,
    stats: () => ['admissions', 'stats'] as const,
    list: (page: number, limit: number, filters: object) =>
      ['admissions', 'list', page, limit, filters] as const,
  },
  installments: {
    all: ['installments'] as const,
    stats: () => ['installments', 'stats'] as const,
    overdue: () => ['installments', 'overdue'] as const,
    list: (page: number, limit: number, filters: object) =>
      ['installments', 'list', page, limit, filters] as const,
  },
  users: {
    all: ['users'] as const,
    list: (page: number, limit: number, search: string) =>
      ['users', 'list', page, limit, search] as const,
  },
  appSettings: {
    all:    ['appSettings'] as const,
    detail: () => ['appSettings', 'detail'] as const,
  },
  master: {
    all:  (resource: string) => [resource] as const,
    list: (resource: string) => [resource, 'list'] as const,
  },
} as const;
